import { render, staticRenderFns } from "./MyIntegral.vue?vue&type=template&id=4837107a&scoped=true&"
import script from "./MyIntegral.vue?vue&type=script&lang=js&"
export * from "./MyIntegral.vue?vue&type=script&lang=js&"
import style0 from "./MyIntegral.vue?vue&type=style&index=0&id=4837107a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837107a",
  null
  
)

export default component.exports